// Feature flags switched on the CDP page arrive as experienceData.features. Missing is off.

// A full experience payload, or any object that carries its `features` list.
export type FeatureSource =
  | { features?: readonly string[] | null }
  | null
  | undefined;

export function isFeatureOn(
  experienceData: FeatureSource,
  key: string,
): boolean {
  const features = experienceData != null ? experienceData.features : null;
  return Array.isArray(features) && features.indexOf(key) !== -1;
}
